import React, { useEffect, useState } from 'react';
import '../../../style/myContent.css';
import CreateResourceSetModal from '../components/createResourceSetModal/createResourceSetModal';
import CustomToast from '../../../../../components/Toast';
import { useGetQuestionSetsMutation, useGetCanShowDeletedMutation } from '../../../../../features/authentication/qSetApiSlice';
import { languages } from '../../../utils/contants';
import { useGetShowDeletedTeacherSetsMutation, useUpdateShowDeletedTeacherSetsMutation } from '../../../../../features/authentication/persistApiSlice';
import SkeletonGrid from '../../../../../components/SkeletonLoader/SkeletonGrid';
import SetListing from '../../../components/SetListing';
import EmptySet from '../../../components/EmptySet';
import ActivityTypes from '../../../../../enums/activityTypes';

const ResourceSets = () => {
  const [updateShowDeletedSetsPersist] = useUpdateShowDeletedTeacherSetsMutation();
  const [openCreateResource, setOpenCreateResource] = useState(false);
  const [resourceSets, setResourceSets] = useState(null);
  const [skip, setSkip] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const takeSize = 9;
  const [showDeletedSets, setShowDeletedSets] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [showDisplayDeletedSetCheckbox, setShowDisplayDeletedSetCheckbox] = useState(false);
  
  const [getQuestionSets] = useGetQuestionSetsMutation();
  const [getShowDeletedSetsPersist] = useGetShowDeletedTeacherSetsMutation();
  const [getCanShowDeleted] = useGetCanShowDeletedMutation();
  
  useEffect(() => {
    getShowDisplayDeletedSetCheckboxAsync();
    getShowDeletedPersistAsync();
  }, []);

  useEffect(() => {
    if(showDeletedSets != null)
      getResourceSetsAsync(skip, takeSize, searchText, showDeletedSets);
  }, [showDeletedSets]);

  const getShowDeletedPersistAsync = async () => {
    let response = await getShowDeletedSetsPersist().unwrap();
    setShowDeletedSets(response);
    return response;
  };
  
  const getResourceSetsAsync = async(skip, take, searchText, showDeletedSets) => {
    if(!isSearching)
      setIsLoading(true);
    try{
      const options = {
        skip: skip,
        take: take,
        searchString: searchText,
        activityTypes : [ActivityTypes.Documents],
        showDeleted : showDeletedSets
      };
      
      let response = await getQuestionSets(options);
      if (response.error) {
        CustomToast(response.error.data.error, 'error');
      }
      else {
        let updatedQuestionSets = response.data.data.map(item => ({
          ...item,
          languageId: languages[0]?.id
        }));

        setResourceSets(updatedQuestionSets);
        setPageCount(Math.ceil(response.data.total/takeSize));
      }
    } catch (error) {
      console.log(error);
    }
    if(!isSearching)
      setIsLoading(false);
  };

  const handleShowDeletedChangesAsync = async() => {
    setShowDeletedSets(!showDeletedSets);
    let options = {
      showDeleted : !showDeletedSets
    };
    await updateShowDeletedSetsPersist(options);
  };
  
  const handleCreateSet = () => {
    setOpenCreateResource(true);
  };

  const getShowDisplayDeletedSetCheckboxAsync = async() => {
    let response = await getCanShowDeleted().unwrap();
    setShowDisplayDeletedSetCheckbox(response.canShowDeleted);
  };

  return (
    <>
      {isLoading || resourceSets == null?
        <SkeletonGrid
          rowCount={3}
          colCount={3} 
          className={'h-150 mb-3'}
        />
        : searchText.length > 0 || resourceSets?.length > 0 ?
          <SetListing
            setSetsList={setResourceSets}
            setsList={resourceSets}
            setOpenCreateSet={setOpenCreateResource}
            setSearchText={setSearchText}
            searchText={searchText}
            pageCount={pageCount}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            getSets={getResourceSetsAsync}
            setSkip={setSkip}
            takeSize={takeSize}
            showDeletedSets ={showDeletedSets}
            handleShowDeletedChanges={handleShowDeletedChangesAsync}
            isSearching={isSearching}
            setIsSearching={setIsSearching}
            showDisplayDeletedSetCheckbox={showDisplayDeletedSetCheckbox}
          />
          :
          <EmptySet
            handleCreateSet={handleCreateSet}
            showDeletedSets={showDeletedSets}
            handleShowDeletedChanges={handleShowDeletedChangesAsync}
            showDisplayDeletedSetCheckbox={showDisplayDeletedSetCheckbox}
          />
      }

      <CreateResourceSetModal
        showModal={openCreateResource}
        setShowModal={() => setOpenCreateResource(false)}
      />
    </>
  );
};
  
export default ResourceSets;